<template>
  <div class="hello">

      <search :items="contacts"></search>

<!--
       <div class="user-list" v-for="contact in contacts">
          <div class="columns flex spacebetween stretch contact">
            <div class="column ">
              <p class="user-list__header" v-if=" contact.company ">{{contact.company}} {{contact.companycity}}</p>
              <p class="user-list__header" v-if=" contact.lastname ">{{contact.firstname}} {{contact.lastname}}</p>              
            </div>
            <div class="column right">
              <router-link class="button icon icon-chevron-right" v-bind:to="{ name: 'ViewContact', params: { contact: contact.slug }}">View Person</router-link>
            </div>
          </div>
        </div>
-->

    
  </div>
</template>

<script>
import firebase from 'firebase'  
import Search from '@/components/Search'

export default {
  name: 'Hello',
  components: {
    Search
  },  
  data () {
    return {
      contacts: [],
      loading: true,
    }
  },
  mounted () {
        
        firebase.firestore().collection('contacts').get().then((querySnapshot) => { //orderBy("lastname","asc").orderBy('company','asc')
          this.loading = false
          var tempcontacts = []
          querySnapshot.forEach((doc) => {
            let data = {
              'sortname' : doc.data().lastname && doc.data().lastname != null ? doc.data().lastname.toLowerCase() : doc.data().company.toLowerCase(),
              'id': doc.id,
              'company': doc.data().company,
              'companyzipcode':doc.data().companyzipcode,
              'companyaddress':doc.data().companyaddress,
              'companycity':doc.data().companycity,
              'firstname': doc.data().firstname,
              'lastname': doc.data().lastname,
              'emailaddress': doc.data().emailaddress,
              'phonenumber': doc.data().phonenumber,
              'typ': doc.data().typ,
              'slug': doc.data().slug,

              'stapler': doc.data().stapler,
              'birthday': doc.data().birthday,
              'versnr': doc.data().versnr,
              'engl': doc.data().engl,
              'sivv': doc.data().sivv,
              'eh': doc.data().eh,
              'sibe': doc.data().sibe,
              'dat': doc.data().dat,
              'winde': doc.data().winde,
              'kran': doc.data().kran,
              
              'spritzen' : doc.data().spritzen,
              'mauern' : doc.data().mauern,
              'faser' : doc.data().faser

            }
            console.log(data.company)
            if( typeof data.company == 'undefined' || data.company =="")
            tempcontacts.push( data )
            console.log(data);
          })
          this.contacts = _.orderBy( tempcontacts, ['sortname'], ['asc'] ) 
          //this.contacts.foreach( function(i) { console.log(i.sortname)})
          //this.contacts.forEach(function(c, index, arr){ console.log(c.sortname) } )
          tempcontacts = null
        })
      }  ,
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hello { padding: 0.9333333em 0.9333333em 0.9333333em; }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue